import { LanguageSelect } from './component';

export * from './component';
export default LanguageSelect;
